module.exports = __webpack_public_path__ + "src/assets/img/startersMenu.fdb5ef78.jpg";